// TYPE
export const CARRIAGE_TYPE_FCL = 'fcl'
export const CARRIAGE_TYPE_LCL = 'lcl'
type TCarriageTypeFcl = typeof CARRIAGE_TYPE_FCL
type TCarriageTypeLcl = typeof CARRIAGE_TYPE_LCL
export type TCarriageType = TCarriageTypeFcl | TCarriageTypeLcl

// MODE
export const CARRIAGE_MODE_SEA = 'sea'
export const CARRIAGE_MODE_AIR = 'air'
export const CARRIAGE_MODE_SEA_AIR = 'seaAir'
export const CARRIAGE_MODE_RAIL = 'rail'
export const carriageModeMap = {
  [CARRIAGE_MODE_SEA]: 'Sea',
  [CARRIAGE_MODE_AIR]: 'Air',
  [CARRIAGE_MODE_SEA_AIR]: 'SeaAir',
  [CARRIAGE_MODE_RAIL]: 'Rail',
}
type TCarriageModeSea = typeof CARRIAGE_MODE_SEA
type TCarriageModeAir = typeof CARRIAGE_MODE_AIR
type TCarriageModeSeaAir = typeof CARRIAGE_MODE_SEA_AIR
type TCarriageModeRail = typeof CARRIAGE_MODE_RAIL
export type TCarriageMode = TCarriageModeSea | TCarriageModeAir | TCarriageModeSeaAir | TCarriageModeRail
